import { clsx } from 'clsx';
import { IWithClassname } from '@/models/common';
import s from './Rating.module.scss';

interface Props extends IWithClassname {
  score?: number;
}

const maxScore = 5;

export const Rating = ({ score = 0 }: Props) => {
  return (
    <div className={s.stars}>
      {Array(maxScore).fill('').map((_, i) => {
        return (
          <svg
            key={i}
            className={clsx(s.stars__star, { [s.stars__star_active]: i < score })}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#E1DCEB" />
          </svg>
        );
      })}
    </div>
  );
};